import React from 'react';

// Lib
import { decodeHtmlEntity } from 'lib/helpers';

// components
import Img from 'components/Img';

// Type
import { TTag } from 'pages/Search/type';

// Interface
interface ITag {
	item: TTag,
	deleteTag?: (item: number) => void,
}

export const Tag: React.FC<ITag> = (props) => {
	const { item, deleteTag } = props;
	const { name, targetId } = item;

	const getTitle = (item: string) => (
		<div
			className="tag__title"
			dangerouslySetInnerHTML={{ __html: decodeHtmlEntity(item) }}
		/>
	);

	return (
		<div className="tag relative">
			{getTitle(name || '')}

			<span
				className="tag__close"
				onClick={() => deleteTag ? deleteTag(targetId || 0) : null}
			>
				<Img isSvg name="crossSvg" className="tag__cross" />
			</span>
		</div>
	);
};

export default Tag;
